export default __webpack_public_path__ + "static/0231-018a34f6849fdbe6e4a22ace09840b7c.png";